export const EMAIL_REGEX =
  /^([\w-+.]+@([\w-]+\.)+[\w-]{2,5})(,\s*[\w-+.]+@([\w-]+\.)+[\w-]{2,5})*$/;

export function emailIsValid(email: string): boolean {
  return EMAIL_REGEX.test(email);
}
